<style lang="scss" scoped>
/* 中控编辑弹窗：左「中控信息」表单（中控号回车/失焦自动加载）+ 右「本次变更影响」实时面板 */
.ce__forms {
    display: flex;
    align-items: stretch;
    gap: 12px;
}

.ce__form-card {
    flex: 0 0 46%;
    min-width: 0;
    margin-bottom: 0;
}

.ce__impact-card {
    flex: 1;
    min-width: 0;
    margin-bottom: 0;
}

.ce__card-head {
    font-weight: bold;
}

.ce__row {
    display: flex;
    align-items: center;
    gap: 6px;
}

.ce__row .el-input {
    flex: 1;
    min-width: 0;
}

.ce__trace-btn {
    flex: none;
}

.ce__impact-empty {
    padding: 30px 0;
    text-align: center;
    font-size: 13px;
    line-height: 22px;
    color: #c0c4cc;
}

.ce__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 10px;
}

.ce__sec-title {
    margin: 12px 0 6px;
    font-size: 13px;
    font-weight: bold;
    color: #303133;
}

.ce__diff {
    list-style: none;
}

.ce__diff li {
    display: flex;
    align-items: baseline;
    gap: 8px;
    padding: 6px 8px;
    font-size: 13px;
}

.ce__diff li:nth-child(odd) { background: #f6f8fa; }

.ce__diff .ce__f { flex: 0 0 90px; color: #606266; }

.ce__diff .ce__old {
    color: #909399;
    text-decoration: line-through;
    word-break: break-all;
}

.ce__diff .ce__arr { color: #c0c4cc; }

.ce__diff .ce__new {
    color: #0d9469;
    font-weight: bold;
    word-break: break-all;
}

.ce__diff .ce__new--empty { color: #909399; font-weight: normal; }

.ce__note {
    padding: 8px 10px;
    margin-bottom: 8px;
    border-radius: 4px;
    font-size: 12px;
    line-height: 20px;
}

.ce__note--info { background: #f4f4f5; color: #909399; }
.ce__note--ok { background: #f0f9eb; color: #67c23a; }
.ce__note--warn { background: #fdf6ec; color: #b88230; }

.ce__warn-text { color: #e6a23c; }

/* 窄屏：两列堆叠为上下 */
@media (max-width: 768px) {
    .ce__forms { flex-direction: column; }
    .ce__form-card { flex: 1; }
}
</style>

<style lang="scss">
/* append-to-body 弹窗脱离组件作用域：宽度由 c-el-dialog(96%) 自适应，修饰类单独封顶 */
.asset-dialog--control-edit {
    margin-top: 5vh !important;
    max-width: 1080px;

    .el-input.is-disabled .el-input__inner,
    .el-input--readonly .el-input__inner {
        color: #303133;
    }

    /* 两列窄栏下日期选择器随栏宽自适应 */
    .el-date-editor {
        width: 100%;
        max-width: 100%;
    }
}
</style>

<template>
    <el-dialog title="中控编辑" :visible.sync="visible" append-to-body custom-class="c-el-dialog asset-dialog asset-dialog--control-edit" :close-on-click-modal="false" @closed="resetAll">
        <div class="ce">
            <div class="ce__forms">
                <!-- 左：中控信息。中控号即入口：输入后回车或失焦自动查询加载，已存在回填档案（修改），不存在空表单（新建） -->
                <el-card shadow="never" class="ce__form-card">
                    <div slot="header" class="ce__card-head">中控信息</div>
                    <el-form label-width="100px" size="small" @submit.native.prevent>
                        <el-form-item label="中控号">
                            <div class="ce__row">
                                <el-input v-model.trim="controlNo" :disabled="loading || saving" placeholder="输入中控号，回车或离开输入框自动加载" @keyup.enter.native="loadControl" @blur="loadControl" />
                                <el-button class="ce__trace-btn" size="small" title="追踪（全链路日志）" :disabled="!controlNo" @click="trace(controlNo)"><i class="fa fa-crosshairs"></i></el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="中控 SN"><el-input v-model.trim="form.controlSN" maxlength="32" show-word-limit :disabled="!loaded" /></el-form-item>
                        <el-form-item label="中控型号"><el-input v-model.trim="form.model" maxlength="50" show-word-limit :disabled="!loaded" /></el-form-item>
                        <el-form-item label="设备到期日期"><el-date-picker v-model="form.deviceExpiryDate" type="date" value-format="yyyy-MM-dd" clearable :disabled="!loaded" /></el-form-item>
                        <el-form-item label="车架号">
                            <div class="ce__row">
                                <el-input v-model.trim="form.chassisNo" maxlength="32" :disabled="!loaded" placeholder="要绑定的目标车架号" />
                                <el-button class="ce__trace-btn" size="small" title="追踪（全链路日志）" :disabled="!form.chassisNo" @click="trace(form.chassisNo)"><i class="fa fa-crosshairs"></i></el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                </el-card>

                <!-- 右：本次变更影响。随左侧修改实时刷新：状态标签 + 字段级 diff + 目标车架待解绑清单 -->
                <el-card shadow="never" class="ce__impact-card">
                    <div slot="header" class="ce__card-head">本次变更影响</div>
                    <div v-if="!loaded" class="ce__impact-empty">在左侧输入中控号（回车或离开输入框）<br>这里实时显示本次修改的全部影响</div>
                    <template v-else>
                        <div class="ce__tags">
                            <el-tag size="mini" :type="mode === 'edit' ? 'warning' : 'success'">{{ mode === 'edit' ? `中控 ${loadedNo} 已存在 · 将更新` : `中控 ${loadedNo} 无档案 · 将新建` }}</el-tag>
                        </div>
                        <template v-if="diffs.length">
                            <div class="ce__sec-title">字段变更</div>
                            <ul class="ce__diff">
                                <li v-for="d in diffs" :key="d.key">
                                    <span class="ce__f">{{ d.label }}</span>
                                    <span class="ce__old">{{ d.old || '（空）' }}</span>
                                    <span class="ce__arr">➜</span>
                                    <span class="ce__new" :class="{ 'ce__new--empty': !d.now }">{{ d.now || '（清空）' }}</span>
                                </li>
                            </ul>
                        </template>
                        <div v-else class="ce__note ce__note--info">尚未修改任何字段</div>
                        <template v-if="form.chassisNo">
                            <div class="ce__sec-title">
                                需要解绑清单
                                <el-tag v-if="chassisChanged && occupants.length" size="mini" type="warning">{{ occupants.length }}</el-tag>
                            </div>
                            <div v-if="!chassisChanged" class="ce__note ce__note--info">车架号未变化，不涉及解绑</div>
                            <template v-else>
                                <div v-if="occupants.length" class="ce__note ce__note--warn">确认执行后，以下 {{ occupants.length }} 个中控将自动解除与该车架的绑定（档案保留，仅清空车架号）</div>
                                <div v-else class="ce__note ce__note--ok">目标车架当前没有绑定其他中控，无需解绑</div>
                                <el-table v-if="occupants.length" :data="occupants" border size="mini" max-height="220">
                                    <el-table-column label="中控号" prop="controlNo" min-width="140" show-overflow-tooltip />
                                    <el-table-column label="中控 SN" min-width="110" show-overflow-tooltip>
                                        <template slot-scope="scope">{{ scope.row.controlSN || '-' }}</template>
                                    </el-table-column>
                                    <el-table-column label="说明" min-width="150">
                                        <template><span class="ce__warn-text">将自动解绑当前关联</span></template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </template>
                    </template>
                </el-card>
            </div>
        </div>
        <span slot="footer">
            <el-button :disabled="saving" @click="visible = false">取消</el-button>
            <el-button type="primary" :loading="saving" :disabled="!canExec" @click="save"><i class="fa fa-check"></i> 确认保存</el-button>
        </span>

        <!-- 编号旁 ◎：直接调起车辆数据的「追踪」抽屉（全链路日志脑图），编号自动识别 -->
        <log-chain-drawer ref="traceDrawer" />
    </el-dialog>
</template>

<script>
    // 中控编辑：统一中控的新增 / 修改 / 换绑（替代台账「新增中控」与行内编辑）
    // 中控号回车/失焦自动加载快照 → 表单修改时右侧实时算 diff + 查目标车架占用 → 「确认保存」直接生效（右侧面板即确认信息）
    import { controlApi } from '@/api/vehicleData'
    import LogChainDrawer from './LogChainDrawer'

    const blankForm = () => ({ controlSN: '', model: '', deviceExpiryDate: null, chassisNo: '' })
    // 字段变更展示顺序与标签（与中控档案字段对应）
    const diffFields = [
        { key: 'chassisNo', label: '车架号' },
        { key: 'controlSN', label: '中控 SN' },
        { key: 'model', label: '中控型号' },
        { key: 'deviceExpiryDate', label: '设备到期日期' }
    ]

    export default {
        name: 'ControlEditDialog',
        components: { LogChainDrawer },
        data() {
            return {
                visible: false,
                loading: false, saving: false, occupantsLoading: false,
                // loadSeq / chassisSeq：查询序号，resetAll 递增以作废在途查询，防止关闭后旧响应回填数据
                loadSeq: 0, chassisSeq: 0,
                controlNo: '',
                // loadedNo：已加载快照的中控号，回车/失焦重复触发时直接跳过，避免清掉正在编辑的内容
                loadedNo: '', mode: '', ctrlRow: null,
                form: blankForm(),
                // lastQueriedChassis：占用清单对应的查询基准（车架号变化即重查）
                lastQueriedChassis: '', occupants: [],
                chassisTimer: null
            }
        },
        computed: {
            loaded() { return !!this.mode },
            // 车架号是否相对快照变化（决定是否涉及解绑）
            chassisChanged() {
                if (!this.loaded) return false
                return this.fieldOf(this.ctrlRow, 'chassisNo') !== (this.form.chassisNo || '')
            },
            diffs() {
                if (!this.loaded) return []
                return diffFields
                    .map(f => ({ ...f, old: this.fieldOf(this.ctrlRow, f.key), now: this.form[f.key] || '' }))
                    .filter(d => d.old !== d.now)
            },
            canExec() { return this.loaded && this.diffs.length > 0 && !this.loading && !this.saving && !this.occupantsLoading }
        },
        watch: {
            // 车架号变化即重查占用与档案（防抖 400ms）；查询基准未变时跳过
            'form.chassisNo'(val) {
                if (val === this.lastQueriedChassis) return
                clearTimeout(this.chassisTimer)
                this.chassisTimer = setTimeout(() => this.queryChassis(), 400)
            }
        },
        methods: {
            // 档案字段统一转字符串（日期截到 yyyy-MM-dd），空值归一为 ''，供 diff 比对
            fieldOf(row, key) {
                const v = row ? row[key] : null
                return v ? (key === 'deviceExpiryDate' ? String(v).slice(0, 10) : String(v)) : ''
            },
            open(controlNo = '') {
                this.resetAll()
                this.controlNo = controlNo || ''
                this.visible = true
                if (this.controlNo) this.loadControl()
            },
            resetAll() {
                this.loadSeq++
                this.chassisSeq++
                clearTimeout(this.chassisTimer)
                Object.assign(this, { loading: false, saving: false, occupantsLoading: false, controlNo: '', loadedNo: '', mode: '', ctrlRow: null, lastQueriedChassis: '', occupants: [] })
                this.form = blankForm()
            },
            // 中控号回车 / 失焦：查询加载该中控当前档案；同一编号已加载时跳过
            async loadControl() {
                const no = this.controlNo
                if (!no || this.loading || this.saving) return
                if (this.loaded && no === this.loadedNo) return
                const seq = ++this.loadSeq
                this.loading = true
                try {
                    const res = await controlApi.list({ page: 1, size: 100, keywords: no })
                    if (seq !== this.loadSeq) return
                    const row = (res.items || []).find(x => x.controlNo === no) || null
                    this.ctrlRow = row
                    this.mode = row ? 'edit' : 'new'
                    this.loadedNo = no
                    this.form = {
                        controlSN: row ? row.controlSN || '' : '',
                        model: row ? row.model || '' : '',
                        deviceExpiryDate: row && row.deviceExpiryDate ? String(row.deviceExpiryDate).slice(0, 10) : null,
                        chassisNo: row ? row.chassisNo || '' : ''
                    }
                    this.$message.info(row ? `已加载中控 ${no} 的当前档案（修改模式）` : `中控 ${no} 不存在，进入新建模式`)
                    // 回填后占用清单的排除主体（当前中控号）可能变化，强制重查
                    this.lastQueriedChassis = ''
                    await this.queryChassis()
                } catch (_) {
                    if (seq !== this.loadSeq) return
                    this.ctrlRow = null
                    this.mode = ''
                    this.loadedNo = ''
                    this.form = blankForm()
                } finally {
                    if (seq === this.loadSeq) this.loading = false
                }
            },
            // 目标车架占用查询：列出绑定该车架的其他中控（需要解绑清单，排除当前中控）
            async queryChassis() {
                const chassisNo = this.form.chassisNo
                if (!chassisNo) {
                    this.chassisSeq++
                    this.lastQueriedChassis = ''
                    this.occupants = []
                    return
                }
                const seq = ++this.chassisSeq
                this.occupantsLoading = true
                try {
                    const occRes = await controlApi.list({ page: 1, size: 100, keywords: chassisNo })
                    if (seq !== this.chassisSeq || this.form.chassisNo !== chassisNo) return
                    this.occupants = (occRes.items || []).filter(x => (x.chassisNo || '').trim() === chassisNo && x.controlNo !== this.controlNo)
                    this.lastQueriedChassis = chassisNo
                } catch (_) {
                    if (seq !== this.chassisSeq) return
                    this.occupants = []
                } finally {
                    if (seq === this.chassisSeq) this.occupantsLoading = false
                }
            },
            // 中控整档提交（解绑侧保持原值仅清空车架号）
            controlInput(row, chassisNo) {
                return {
                    controlNo: row.controlNo, controlSN: row.controlSN || '', model: row.model || '',
                    chassisNo, deviceExpiryDate: row.deviceExpiryDate ? String(row.deviceExpiryDate).slice(0, 10) : null
                }
            },
            // 保存：解绑占用中控 → 新建/更新本中控档案并绑定目标车架；车架档案不在此建档
            async save() {
                if (!this.canExec) return
                const no = this.loadedNo
                const chassisNo = this.form.chassisNo || ''
                this.saving = true
                let saved = false
                try {
                    const bindingInput = {
                        controlNo: no, controlSN: this.form.controlSN || '', model: this.form.model || '',
                        chassisNo, deviceExpiryDate: this.form.deviceExpiryDate || null
                    }
                    for (const o of this.occupants) await controlApi.update(o.id, this.controlInput(o, ''))
                    if (this.ctrlRow) await controlApi.update(this.ctrlRow.id, bindingInput)
                    else await controlApi.create(bindingInput)
                    this.$message.success(`已保存：中控 ${no}${chassisNo ? ` → 车架 ${chassisNo}` : '（已解绑）'}`)
                    this.$emit('done')
                    saved = true
                } catch (_) { /* 请求层已提示错误，保留表单内容便于修正后重试 */ } finally {
                    this.saving = false
                    if (saved) {
                        // 以保存后的最新档案为新快照，继续编辑时影响面板从新状态计算（须在 saving 复位后重载，否则被守卫拦截）
                        this.loadedNo = ''
                        this.lastQueriedChassis = ''
                        await this.loadControl()
                    }
                }
            },
            // 编号旁 ◎：调起「追踪」抽屉（车辆号/中控号/车架号自动识别建图）
            trace(no) { if (no) this.$refs.traceDrawer.open(no) }
        }
    }
</script>
